import settings         from './settings';

import sweetalert       from 'sweetalert';
import nunjucks         from 'nunjucks';
import 'tooltipsy';
import Highcharts   from 'highcharts';
import Exporting from 'highcharts/modules/exporting';     // Image support
import ExportData from 'highcharts/modules/export-data';  // CSV/XLS support
Exporting(Highcharts);
ExportData(Highcharts);

import preloadNunjucks from './preload/nunjucks';
var nunjucksEnv = preloadNunjucks();

import Avatar       from './ui/avatar';
import CuratedDigest         from './ui/curated-digest';
import Filters      from './ui/filters';
import PostBox      from './ui/postbox';
import Modal        from './ui/modal';
import Post         from './ui/post';
import ProTips      from './ui/pro-tips';
import Tabs         from './ui/tabs';
import editSchedule from './ui/schedule/edit';
import ShareBox     from './ui/sharebox';
import Competitors  from './ui/competitors';
import Statistics   from './ui/statistics';
import Trends       from './ui/trends';
import Discover     from './ui/discover';
import ContentBox   from './ui/content-box';
import MobileMenu   from './ui/mobile-menu';
import Slideout     from './ui/slideout';
import Accordion    from './ui/accordion';
import JumpTo       from './ui/jump-to';
import MyChannels   from './ui/my-channels';

import LivePosts    from './helper/liveposts';
import Ajax         from './helper/ajax';

import pageAlert        from './helper/pagealert';
import welcome          from './helper/welcome';
import repeatable       from './helper/repeatable';
import selectize        from './helper/selectize';
import datepicker       from './helper/datepicker';
import visibilitySwitch from './helper/visibility-switch';
import inviteForm       from './helper/invite-form';
import pageSelection    from './helper/page-selection';
import discoverHelper   from './helper/discover';
import jQCloud   from './helper/jqcloud';

import Snapshot from './model/snapshot';

import toast from './vendor/toast.min.js';
toast();

export function bootstrap() {
    let avatar = new Avatar($('#profile-avatar__form')),
        curatedDigest = new CuratedDigest(),
        post    = new Post(),
        liveposts = new LivePosts(post),
        postbox = new PostBox($('.postbox'), liveposts, post),
        $tabs   = $('.tabs'),
        ajax = new Ajax(),
        filters = new Filters($('.filter-box ')),
        trends = new Trends(liveposts),
        tips    = new ProTips($('.pro-tips')),
        discover = new Discover(),
        stats     = new Statistics(),
        comtentbox = new ContentBox(),
        mobilemenu = new MobileMenu(),
        slideout = new Slideout(),
        accordion = new Accordion('.accordion'),
        competitors = new Competitors(),
        snapshot = new Snapshot(),
        jumpto = new JumpTo(),
        mychannels = new MyChannels();

    editSchedule();
    liveposts.startPoll();

    window.modals = [];

    $('.modal').each(function () {
      let modal = new Modal($(this));
      modal.init();
      modals[modal.id()] = modal;
    });

    $tabs.each(function(k, v) {
        new Tabs($(v));
    });

    pageAlert();
    welcome();
    repeatable();
    selectize();
    datepicker();
    visibilitySwitch();
    inviteForm();
    pageSelection();
    discoverHelper();

    let name = 'share',
        url = window.location.href,
        field = name.replace(/[\[\]]/g, "\\$&"),
        regex = new RegExp("[?&]" + field + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);

    if (!results || !results[2]) {
        var shareId = null;
    } else {
        var shareId = decodeURIComponent(results[2].replace(/\+/g, " "));

        var request = $.ajax({
              headers   : settings.api_headers,
              url       : 'posts/' + shareId,
              type      : 'GET',
              dataType  : 'json'
          });

        request.always(function(data, textStatus, jqXHR) {
          if (jqXHR.status == 200) {

            var sharebox = new ShareBox();
            sharebox.create(data.post.post, data.post.id, false, (data.post.images !== 'undefined') ? data.post.images : [],[],[],"",data.post.formattedLinkedinText);

          }
        });
    }





    $('.page')
      .on('click', 'a.js-external', function(ev) {
        window.open(this.href);
        ev.preventDefault();
      })
      // Make it explicit - original code is hiding
      .off('click', '.dropdown__trigger__label')
      .on('click', '.dropdown__trigger__label', (ev) => {
          ev.preventDefault();
          ev.stopPropagation();
          let $me = $(ev.currentTarget),
              $pointed = $('#'+$me.attr('for')),
              $ddt = $me.siblings('.dropdown__trigger'),
              $dd = $me.siblings('.dropdown, .csv-upload');

         if (!$me.data('active')) {
             $ddt.prop('checked', true);
             $me.data('active', true);
             $dd.addClass('is-active')
                .removeClass('is-hidden')
                .removeClass('visually-hidden');


            if ($me.hasClass('btn--share-method-selector')) {
                var pos = $me.position();
                var $shareBtn = $('.btn--share');

                $dd.css({
                    position: "absolute",
                    top: ((pos.top - $dd.height()) - 48) + 'px',
                    left: ((pos.left - $dd.width()) + 48) + 'px'
                });
            }

         } else {
             $ddt.prop('checked', false);
             $me.data('active', false);
             $dd.removeClass('is-active')
                .addClass('is-hidden')
                .addClass('visually-hidden')
         }
      })
      .on('click', function(ev) {
          let $me = $(ev.target),
              $labels = $me.parents('.dropdown__trigger__label'),
              isTrigger = 0 < $labels.length;
          if (isTrigger) return;
        $('.dropdown__trigger').each(function(k, v) {
          let $me = $(v);
          if (!!! $me.data('trigger-hide-only')) {
            $me.prop('checked', false);
            $me.siblings('.dropdown').removeClass('is-active');
          }
        });
      })
      .on('click', '.toggle-section-visibility', function(ev) {
          ev.preventDefault();
          var $me = $(ev.target),
              selector = $me.data('toggle'),
              $toggle = $(selector);

          if (!$me.data('active')) {
              $me.data('active', true);
              $toggle.removeClass('is-hidden')
                 .removeClass('visually-hidden');
          } else {
              $me.data('active', false);
              $toggle.addClass('is-hidden')
                 .addClass('visually-hidden')
          }
      })
      .on('click', '.js-delete', function(ev) {
          ev.preventDefault();

          var $me = $(this).blur(),
              $my_wrap = $me.parents($me.data('parent')),
              url = $me.attr('href'),
              item = $me.data('item') || 'item',
              request;

              request = $.ajax({
                headers: settings.api_headers,
                url: url,
                type: 'DELETE',
                dataType: 'json'
              });

              request.always(function(data, textStatus, jqXHR) {
                if (data.status == 200) {
                  $my_wrap.slideUp(250, function() {
                    $my_wrap.remove();
                    if (item == 'comment') {
                        var $comments_counter = $('.trigger--post-comments span', $($me.data('extra'))),
                            $comments_heading = $('.comments h3', $($me.data('extra'))),
                            old_count = parseInt($comments_counter.text()),
                            new_count = old_count - 1;

                         $comments_counter.text(new_count);
                         $comments_heading.text($comments_heading.text().replace(old_count, new_count));
                         if (new_count == 0) {
                             $comments_heading.text($comments_heading.text().replace('Comment', 'Comments'));
                         } else if (new_count == 1) {
                             $comments_heading.text($comments_heading.text().replace('Comments', 'Comment'));
                         }
                    }
                  });

                }
            });
        })
        .on('click', '.js-delete-confirm', function(ev) {
            ev.preventDefault();

            var $me = $(this).blur(),
                $my_wrap = $me.parents($me.data('parent')),
                url = $me.attr('href'),
                item = $me.data('item') || 'item',
                request;

            sweetalert({
                title: "Are you sure?",
                text: "Are you sure you want to delete this " + item + "?",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it.",
                closeOnConfirm: false
              },
            function(isConfirm) {
              $me.blur();

              if (isConfirm) {
                request = $.ajax({
                  headers: settings.api_headers,
                  url: url,
                  type: 'DELETE',
                  dataType: 'json'
                });

                request.always(function(data, textStatus, jqXHR) {
                  if (data.status == 200) {
                    $my_wrap.slideUp(250, function() {
                      $my_wrap.remove();
                      if (item == 'comment') {
                          var $comments_counter = $('.trigger--post-comments span', $($me.data('extra'))),
                              $comments_heading = $('.comments h3', $($me.data('extra'))),
                              old_count = parseInt($comments_counter.text()),
                              new_count = old_count - 1;

                           $comments_counter.text(new_count);
                           $comments_heading.text($comments_heading.text().replace(old_count, new_count));
                           if (new_count == 0) {
                               $comments_heading.text($comments_heading.text().replace('Comment', 'Comments'));
                           } else if (new_count == 1) {
                               $comments_heading.text($comments_heading.text().replace('Comments', 'Comment'));
                           }
                      }
                    });
                    if ('content' == item) {
                      sweetalert.close();
                    } else {
                      sweetalert("Deleted!", "Your " + item + " has been deleted.", "success");
                    }
                  } else {
                    sweetalert("Sorry!", "There was a problem deleting your " + item + ".", "error");
                  }
                });
              }
            });
          })
        .on('click', '.js-delete-confirm-social', function(ev) {
            ev.preventDefault();

            var $me = $(this).blur(),
                $my_wrap = $me.parents($me.data('parent')),
                url = $me.attr('href'),
                item = $me.data('item') || 'item',
                request;

            sweetalert({
                title: "Are you sure?",
                text: "Are you sure you want to delete this " + item + "? All your schduled share with this account, will also delete.",
                type: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, delete it.",
                closeOnConfirm: false
              },
            function(isConfirm) {
              $me.blur();

              if (isConfirm) {
                request = $.ajax({
                  headers: settings.api_headers,
                  url: url,
                  type: 'DELETE',
                  dataType: 'json'
                });

                request.always(function(data, textStatus, jqXHR) {
                  if (data.status == 200) {
                    $my_wrap.slideUp(250, function() {
                      $my_wrap.remove();
                      if (item == 'comment') {
                          var $comments_counter = $('.trigger--post-comments span', $($me.data('extra'))),
                              $comments_heading = $('.comments h3', $($me.data('extra'))),
                              old_count = parseInt($comments_counter.text()),
                              new_count = old_count - 1;

                           $comments_counter.text(new_count);
                           $comments_heading.text($comments_heading.text().replace(old_count, new_count));
                           if (new_count == 0) {
                               $comments_heading.text($comments_heading.text().replace('Comment', 'Comments'));
                           } else if (new_count == 1) {
                               $comments_heading.text($comments_heading.text().replace('Comments', 'Comment'));
                           }
                      }
                    });
                    if ('content' == item) {
                      sweetalert.close();
                    } else {
                      sweetalert("Deleted!", "Your " + item + " has been deleted.", "success");
                    }
                  } else {
                    sweetalert("Sorry!", "There was a problem deleting your " + item + ".", "error");
                  }
                });
              }
            });
          })
    .on('click', '.discover__share', function(ev) {
        ev.preventDefault();

        var $me       = $(this).blur(),
            $post     = $me.parents('.post'),
            url       = $me.attr('href'),
            item      = $me.data('item') || 'item',
            request = $.ajax({
              headers   : settings.api_headers,
              url       : url,
              type      : 'POST',
              dataType  : 'json'
            }),
            scroll = $(window).scrollTop();

        request.always(function(data, textStatus, jqXHR) {
          if (jqXHR.status == 201) {
            sweetalert("Amped!", "Your " + item + " has been amped.", "success");
            $('body').removeClass('stop-scrolling');
            $(window).scrollTop(scroll);
            $post.remove();
          } else {
            sweetalert("Sorry!", "There was a problem amping your " + item + ".", "error");
            $('body').removeClass('stop-scrolling');
            $(window).scrollTop(scroll);
          }
        });
    })
    .on('change', '.js-change-update', function(ev) {
        ev.preventDefault();

          var $me = $(this).blur(),
              $my_wrap = $me.parents($me.data('parent')),
              url = $me.attr('href'),
              item = $me.data('item') || 'item',
              request;

          sweetalert({
              title: "Are you sure?",
              text: "Are you sure you want to delete this " + item + "?",
              type: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it.",
              closeOnConfirm: false
            },
          function(isConfirm) {
            $me.blur();

            if (isConfirm) {
              request = $.ajax({
                headers: settings.api_headers,
                url: url,
                type: 'DELETE',
                dataType: 'json'
              });

              request.always(function(data, textStatus, jqXHR) {
                if (data.status == 200) {
                  $my_wrap.slideUp(250, function() {
                    $my_wrap.remove();
                    if (item == 'comment') {
                        var $comments_counter = $('.trigger--post-comments span', $($me.data('extra'))),
                            $comments_heading = $('.comments h3', $($me.data('extra'))),
                            old_count = parseInt($comments_counter.text()),
                            new_count = old_count - 1;

                         $comments_counter.text(new_count);
                         $comments_heading.text($comments_heading.text().replace(old_count, new_count));
                         if (new_count == 0) {
                             $comments_heading.text($comments_heading.text().replace('Comment', 'Comments'));
                         } else if (new_count == 1) {
                             $comments_heading.text($comments_heading.text().replace('Comments', 'Comment'));
                         }
                    }
                  });
                  if ('content' == item) {
                    sweetalert.close();
                  } else {
                    sweetalert("Deleted!", "Your " + item + " has been deleted.", "success");
                  }
                } else {
                  sweetalert("Sorry!", "There was a problem deleting your " + item + ".", "error");
                }
              });
            }
          });
        })
      .on('click', '.viewmore', function(ev) {
          ev.preventDefault();

          let $me = $(this),
              $table = $('#'+$(this).data('table')),
              $tables = $('#table_container');

          if ($me.data('enabled')) {
              $table.hide();
              $me.addClass('btn--primary');
              $me.text('View More');
              $me.data('enabled', false);
          }
          else {
              $table.detach();
              $tables.prepend($table);
              $table.show();
              $me.removeClass('btn--primary');
              $me.text('View Less');
              $me.data('enabled', true);
          }
      })
      .on('click', '.table--close a', (ev) => {
          ev.preventDefault();

          let $me = $(ev.currentTarget),
              $container = $me.parents('.showtable'),
              containerid = $container[0].id,
              $button = $(`.viewmore[data-table="${containerid}"], .viewmore--ajax[data-table="${containerid}"]`);

          $container.hide();
          $button.addClass('btn--primary');
          $button.text('View More');
          $button.data('enabled', false);
      })
      .on('change', '.js-change-update', function(ev) {
        ev.preventDefault();

          let $me = $(this),
              url = $me.data('url'),
              method = $me.data('method'),
              property = $me.data('property'),
              value = $me.val(),
              reload = $me.data('force-reload') || false,
              data = {},
              request;

          data[property] = value;
          if (method == 'PATCH') {
            data['_method'] = 'PATCH';
            method = 'POST';
          }

          request = $.ajax({
            headers: settings.api_headers,
            url: url,
            type: method,
            data: data,
            dataType: 'json'
          });

          request
            .always(function(data, textStatus, jqXHR) {
              if (data.status != 200) {
                sweetalert('Sorry!', 'There was a problem saving your change', 'error');
              } else {
                sweetalert({
                  title: 'Updated!',
                  text: 'Updated successfully',
                  type: 'success'
                },
                function() {
                  if (reload) {
                    document.location.reload();
                  }
                });
              }
            });
        })
        .on('click', '.js-action-confirm', function(ev) {
          ev.preventDefault();

          let $me = $(this),
              url = $me.data('url'),
              method = $me.data('method'),
              reload = $me.data('force-reload') || false,
              data = {},
              msg_success = $me.data('msg-success') || 'Completed successfully!',
              msg_error = $me.data('.msg-error') || 'Sorry, there was a problem',
              all_data = $me.data(),
              request;

          $.each(all_data, function(k, v) {
            let match = k.match(/param/);

            if (!! match) {
              k = k.replace(/([A-Z])/g, function($1){return "_"+$1.toLowerCase();});
              k = k.replace('param_', '');
              data[k] = v;
            }
          });

          request = $.ajax({
            headers: settings.api_headers,
            url: url,
            type: method,
            data: data,
            dataType: 'json'
          });

          request
            .always(function(data, textStatus, jqXHR) {
              if (data.status != 200) {
                sweetalert('Sorry!', msg_error, 'error');
              } else {
                sweetalert({
                  title: 'Success!',
                  text: msg_success,
                  type: 'success'
                },
                function() {
                  if (reload) {
                    document.location.reload();
                  }
                });
              }
            });
        });

    $('.dropdown, .dropdown__trigger').on('click', function(ev) { ev.stopPropagation() });

    $('body').on('click', 'a.btn--disabled', function () {
        return false;
    });

    $('.form--filter').on('change', 'select', function(ev) {
      Intercom('trackEvent', 'feed-sort');
      $(ev.delegateTarget).submit();
    });

    $('.post')
      .on('click', '.trigger--post-comments', function(ev) {
        var $me = $(this),
            $parent = $(ev.delegateTarget),
            $comments = $parent.find('.comments'),
            $comment_list = $comments.find('.comments__list'),
            post_id       = $parent.data('id'),
            current_user_id = $('.user-profile').data('user-id'),
            request       = $.ajax({
                headers : settings.api_headers,
                url : '/posts/' + post_id + '/comments',
                type : 'GET',
                dataType : 'json'
            });

        request.done(function(data, textStatus, jqXHR) {
          var html = '';
          if (!! data.comments.length) {
            for (var i = data.comments.length - 1; i >= 0; i--) {
              html += nunjucksEnv.render('html/posts/comment.html', {comment: data.comments[i], current_user_id : current_user_id } );
            };
          }
          $comment_list.html(html);
        });
      })
      .on('submit', '.form--comment', function(ev) {
        var $me = $(this),
            $parent = $(ev.delegateTarget),
            $comments = $parent.find('.comments'),
            $comments_counter = $parent.find('.trigger--post-comments span'),
            $comments_title = $parent.find('.comments__title'),
            $comment_list = $comments.find('.comments__list'),
            $comment_box = $me.find('.form__field--comment'),
            post_id = $parent.data('id'),
            request = $.ajax({
              headers: settings.api_headers,
              url: '/posts/' + post_id + '/comments',
              type: 'POST',
              dataType: 'json',
              data: {
                comment: $comment_box.val()
              }
            });

          request.done(function(data, textStatus, jqXHR) {
            var current_user_id = $('.user-profile').data('user-id');

            $comment_list.append(nunjucksEnv.render('html/posts/comment.html', {comment: data.comment, user: data.comment.user, current_user_id : current_user_id}));
            $comment_box.val('');
            var old_num_comments = parseInt($comments_counter.text());
            var new_num_comments = old_num_comments + 1;
            $comments_counter.text(new_num_comments);
            $comments_title.text($comments_title.text().replace(old_num_comments, new_num_comments));
          });

          ev.preventDefault();
      });

    $('.channel-list')
      .on('click', '.channel__delete', function(ev) {
        ev.preventDefault();

        var $me = $(this).blur(),
            $my_row = $me.parents('tr'),
            $my_body = $me.parents('tbody'),
            $my_rows,
            method = $me.data('method'),
            url = $me.attr('href'),
            request;

        sweetalert({
          title: "Are you sure?",
          text: "Are you sure you want to delete this channel?\r\n\r\nAny sub channels will be re-assigned as parent channels",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it.",
          closeOnConfirm: false
        },
        function(isConfirm) {
          $me.blur();

          if (isConfirm) {
            request = $.ajax({
              headers: settings.api_headers,
              url: url,
              type: method,
              dataType: 'json'
            });

            request.always(function(data, textStatus, jqXHR) {
              if (data.status == 200) {
                $my_row.slideUp(250, function() {
                  $my_row.remove();
                  $my_rows = $my_body.find('tr');
                  if ($my_rows.length == 1) {
                    $my_rows.removeClass('is-hidden');
                  }
                });
                sweetalert("Deleted!", "Your channel has been deleted.", "success");
              } else {
                sweetalert("Sorry!", "There was a problem deleting your channel.", "error");
              }
            });
          }
        });
      });
    
      $('.tag-list').on('click', '.tag__delete', function(ev) {
        ev.preventDefault();

        var $me = $(this).blur(),
            $my_row = $me.parents('tr'),
            $my_body = $me.parents('tbody'),
            $my_rows,
            method = $me.data('method'),
            url = $me.attr('href'),
            request;

        sweetalert({
          title: "Are you sure?",
          text: "Are you sure you want to archive this tag? This can be restored via the archived tab if needed.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, archive it.",
          closeOnConfirm: false
        },
        function(isConfirm) {
          $me.blur();

          if (isConfirm) {
            request = $.ajax({
              headers: settings.api_headers,
              url: url,
              type: method,
              dataType: 'json'
            });

            request.always(function(data, textStatus, jqXHR) {
              if (data.status == 200) {
                $my_row.slideUp(250, function() {
                  $my_row.remove();
                  $my_rows = $my_body.find('tr');
                  if ($my_rows.length == 1) {
                    $my_rows.removeClass('is-hidden');
                  }
                });
                sweetalert("Deleted!", "Your tag has been archived.", "success");
              } else {
                sweetalert("Sorry!", "There was a problem archiving your tag.", "error");
              }
            });
          }
        });
      });


      $('.group-list').on('click', '.group__delete', function(ev) {
        ev.preventDefault();

        var $me = $(this).blur(),
            $my_row = $me.parents('tr'),
            $my_body = $me.parents('tbody'),
            $my_rows,
            method = $me.data('method'),
            url = $me.attr('href'),
            request;

        sweetalert({
          title: "Are you sure?",
          text: "Are you sure you want to archive this group? Of Course you can restore it later. ",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, archive it.",
          closeOnConfirm: false
        },
        function(isConfirm) {
          $me.blur();

          if (isConfirm) {
            request = $.ajax({
              headers: settings.api_headers,
              url: url,
              type: method,
              dataType: 'json'
            });

            request.always(function(data, textStatus, jqXHR) {
              if (data.status == 200) {
                $my_row.slideUp(250, function() {
                  $my_row.remove();
                  $my_rows = $my_body.find('tr');
                  if ($my_rows.length == 1) {
                    $my_rows.removeClass('is-hidden');
                  }
                });
                sweetalert("Deleted!", "Your group has been archived.", "success");
              } else {
                sweetalert("Sorry!", "There was a problem archiving your group.", "error");
              }
            });
          }
        });
      });
    let _post = post;

    let isPaginating = false;

    function paginate() {
      isPaginating = true;

      let $posts  = $('.posts'),
        $list   = $posts.find('.posts__list'),
        $me     = $('.posts__footer a'),
        $href   = $me.attr('href'),
        $parent = $me.parents('.posts__footer'),
        post,
        request = $.ajax({
          headers: settings.api_headers,
          url: $href,
          type: 'GET',
          dataType: 'json'
        });

      request.always(function(jqXHR, textStatus) {
        var next_page = $me.data('next-page') + 1,
          next_url = $href.replace(/page=\d+/, 'page='+next_page);

        $me.data('next-page', next_page);
        $me.attr('href', next_url);

        if ($me.data('max-pages') < next_page) {
          $parent.hide();
        } else {
          $parent.show();
        }

      }).done(function(data, textStatus, jqXHR) {
        Post.renderPosts(data.posts, _post, false);
        isPaginating = false;
      });
    }

    if ($('.posts__footer').length) {
      $(window).scroll(function() {
        var footerOffset = $('.posts__footer').offset().top,
          footerOuterHeight = $('.posts__footer').outerHeight(),
          windowHeight = $(window).height(),
          windowScroll = $(this).scrollTop();

          if (windowScroll > (footerOffset + footerOuterHeight - windowHeight - 50) && !isPaginating) {
            paginate();
          }
      });
    }

    $("div[data-embed-image-from]").each(function () {
        var injectTo = $(this);
        var extractFromUrl = $(this).data('embed-image-from');
        var url = 'https://api.embed.ly/1/extract?wmode=opaque&words=30&maxwidth=150&meta_images=1&key=' + settings.preview_key + '&urls=' + encodeURIComponent(extractFromUrl);

        $.ajax({
          url: url,
          dataType: 'jsonp',
          success: function (data) {
              if (data[0].type != 'error') {
                  if (data[0].images.length > 0) {
                      injectTo.append("<img src='" + data[0].images[0].url + "'>");
                  }
              }
            }
        });
    });

    $('.posts').on('click', '.post__content a', function(){
      $(this).attr('target','_blank');
    });

    $('.posts')
      .on('click', '.posts__footer a', function(ev) {
            ev.preventDefault();
            paginate();
      });

      $('.notifications__icon').click(function(ev) {
          var $user = $('.user-profile'),
              $me = $(ev.currentTarget);

          $.get('/users/' + $user.data('user-id') + '/notifications/read', function() {
              // They have now been read
              $me.find('.notifications__number').hide();
          });
      });

      $('.tooltip').tooltipsy({ offset: [0, -10]});
      $('.tooltip--under').tooltipsy({
          offset: [0, 10],
          className: 'tooltipsy tooltipsy-no-arrow'
      });

    $('#form__field--company-page').on('change', function () {
      $('#form__field--source_reference').val($('#form__field--company-page option:selected').val());
    });

    $('#form__field--facebook-page').on('change', function () {
      $('#form__field--source_reference').val($('#form__field--facebook-page option:selected').val());
    });

    // Run post_init functions
    // TODO: Deprecate me - this has been phased out in preference for $(document).ready()
    // if (!! window.SOAMPLI) {
    //   if (!! window.SOAMPLI.post_init && !! window.SOAMPLI.post_init.length) {
    //     $.each(window.SOAMPLI.post_init, function(k, v) {
    //       v();
    //     });
    //   }
    // }

    $('head').append("<style type='text/css'>.pika-single { z-index: 99999 !important; }</style>");

    // Annoyingly had to add this, as the delete confirm js listener wouldn't work
    // so used my own class and added this as a seperate binding
    // also, unable to bind to the body and listen for click on this element, not sure why
    $('.delete_share').on('click', function(ev) {
      ev.preventDefault();

        var $me       = $(this).blur(),
            $my_wrap  = $me.parents($me.data('parent')),
            url       = $me.attr('href'),
            item      = $me.data('item') || 'item',
            request;

        sweetalert({
            title             : "Are you sure?",
            text              : "Are you sure you want to delete this " + item + "?",
            type              : "warning",
            showCancelButton  : true,
            confirmButtonText : "Yes, delete it.",
            closeOnConfirm    : false
          },
        function(isConfirm) {
          $me.blur();

          if (isConfirm) {
            request = $.ajax({
                headers   : settings.api_headers,
                url       : url,
                type      : 'DELETE',
                dataType  : 'json'
              });

            request.always(function(data, textStatus, jqXHR) {
              if (data.status == 200) {
                $my_wrap.slideUp(250, function() {
                  $my_wrap.remove();
                });
                sweetalert("Deleted!", "Your " + item + " has been deleted.", "success");
              } else {
                sweetalert("Sorry!", "There was a problem deleting your " + item + ".", "error");
              }
            });
          }
        });
    });
}
